import React, {useEffect} from 'react';

import {
  Form,
  Input,
  Button,
  Radio,
  Upload,
  Checkbox,
  Row,
  Col,
  Typography,
  Select,
  DatePicker,
  Divider,
  Alert,
  InputNumber,
  Space,
  message,
  AutoComplete,
} from 'antd';
import Flex from '../Flex';
const {Text, Title, Paragraph} = Typography;

import {useInput, useNumber} from 'react-hanger';
import {UserCategory, UserGender, UserGrade} from '../../hooks/apis/useUser';
import moment, {Moment} from 'moment';
import UseSystem from '../../hooks/apis/useSystem';

export interface IUserProfileForm {
  id: number;
  legalName: string;
  category: UserCategory;
  gender: UserGender;
  schoolName: string;
  grade: UserGrade;
  classNo: number;
  coachName: string;
  telephone: string;
  birthDate: Moment;
  remark: string;
}

const UserProfileForm = (props: {form?: IUserProfileForm; isLoading: boolean; onFinish: (value: IUserProfileForm) => any; onCancel?: () => any}) => {
  const [form] = Form.useForm();
  const category = useNumber(undefined as any);
  const grade = useNumber(undefined as any);
  const sysConfig = UseSystem.query();

  useEffect(() => {
    grade.setValue(undefined as any);
  }, [category.value]);

  const gradeList = category.value === UserCategory.小学组 ? [1, 2, 3, 4, 5] : [6, 7, 8, 9, 10, 11, 12];

  const defaultForm: IUserProfileForm = {
    id: 0,
    birthDate: undefined,
    category: undefined,
    classNo: undefined,
    coachName: '',
    gender: undefined,
    grade: undefined,
    legalName: '',
    schoolName: '',
    telephone: '',
    remark: '',
  } as any;

  React.useEffect(() => {
    if (props.form && props.form.legalName) {
      form.setFieldsValue(props.form);
    } else {
      form.setFieldsValue(defaultForm);
    }
    sysConfig
      .request()
      .then()
      .catch();
  }, []);

  return (
    <Form
      labelCol={{span: 6}}
      wrapperCol={{span: 14}}
      layout={'horizontal'}
      form={form}
      onFinish={value => {
        if (!grade.value) {
          message.error('请选择年级');
        } else if (!category.value) {
          message.error('请选择组别');
        } else {
          value.id = props.form?.id || 0;
          value.category = category.value;
          value.grade = grade.value;
          props.onFinish(value as IUserProfileForm);
        }
      }}>
      <Form.Item label={'姓名'} name={'legalName'} rules={[{required: true, max: 20}]}>
        <Input size={'large'} placeholder="请输入姓名" />
      </Form.Item>
      <Form.Item label={'性别'} name={'gender'} rules={[{required: true}]}>
        <Radio.Group>
          <Radio value={UserGender.男}>男</Radio>
          <Radio value={UserGender.女}>女</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item label={'出生日期'} name={'birthDate'} rules={[{required: true}]}>
        <DatePicker size={'large'} placeholder="出生日期" style={{width: '100%'}} />
      </Form.Item>
      <Form.Item label={'组别'} required>
        <Radio.Group value={category.value} onChange={e => category.setValue(e.target.value)}>
          <Radio value={UserCategory.小学组}>小学组</Radio>
          <Radio value={UserCategory.中学组}>中学组</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item label={'学校'} name={'schoolName'} rules={[{required: true, max: 40}]}>
        <AutoComplete size={'large'} placeholder="请输入学校名称" options={sysConfig.data?.schoolNames.map(i => ({value: i})) || []} />
      </Form.Item>
      <Form.Item label={'年级'} rules={[{required: true}]} required>
        <Select style={{width: 120}} size={'large'} value={grade.value} onChange={grade.setValue}>
          {gradeList.map(g => (
            <Select.Option key={g} value={g}>
              {UserGrade[g]}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item label={'班级'} name={'classNo'} rules={[{required: true}]}>
        <Select style={{width: 240}} size={'large'}>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20].map(g => (
            <Select.Option key={g} value={g}>
              {UserGrade[grade.value]} {g} 班
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item label={'指导老师姓名'} name={'coachName'} rules={[{required: true, max: 10}]}>
        <Input size={'large'} placeholder="请输入指导老师姓名" />
      </Form.Item>
      <Form.Item label={'联系电话'} name={'telephone'} rules={[{required: true, len: 11}]}>
        <Input size={'large'} placeholder="请输入联系电话" />
      </Form.Item>
      <Form.Item label={'备注'} name={'remark'}>
        <Input size={'large'} placeholder="可选" />
      </Form.Item>
      <Row>
        <Col span={6} />
        <Col>
          <Space>
            <Button size={'large'} type="primary" loading={props.isLoading} htmlType="submit" className="login-form-button">
              保存
            </Button>
            <Button size={'large'} onClick={props.onCancel}>
              取消
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};

export default UserProfileForm;
